import React from 'react';

export default function ProjectIcon({ active }: { active?: boolean }) {
  return (
    <>
      {active ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M13.1083 1.66675C11.7833 1.66675 11.25 2.20008 11.25 3.52508V6.89175C11.25 8.21675 11.7833 8.75008 13.1083 8.75008H16.475C17.8 8.75008 18.3333 8.21675 18.3333 6.89175V3.52508C18.3333 2.20008 17.8 1.66675 16.475 1.66675"
            stroke="#F7F7F7"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.74935 7.10008V3.31675C8.74935 2.14175 8.21602 1.66675 6.89102 1.66675H3.52435C2.19935 1.66675 1.66602 2.14175 1.66602 3.31675V7.09175C1.66602 8.27508 2.19935 8.74175 3.52435 8.74175H6.89102C8.21602 8.75008 8.74935 8.27508 8.74935 7.10008Z"
            stroke="#F7F7F7"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.89102 18.3333C8.21602 18.3333 8.74935 17.8 8.74935 16.475V13.1083C8.74935 11.7833 8.21602 11.25 6.89102 11.25H3.52435C2.19935 11.25 1.66602 11.7833 1.66602 13.1083V16.475C1.66602 17.8 2.19935 18.3333 3.52435 18.3333"
            stroke="#F7F7F7"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.5 12.9167H17.5"
            stroke="#F7F7F7"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M12.5 16.25H17.5"
            stroke="#F7F7F7"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M18.3333 6.8915V3.52484C18.3333 2.19984 17.8 1.6665 16.475 1.6665H13.1083C11.7833 1.6665 11.25 2.19984 11.25 3.52484V6.8915C11.25 8.2165 11.7833 8.74984 13.1083 8.74984H16.475C17.8 8.74984 18.3333 8.2165 18.3333 6.8915Z"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.74935 7.09984V3.3165C8.74935 2.1415 8.21602 1.6665 6.89102 1.6665H3.52435C2.19935 1.6665 1.66602 2.1415 1.66602 3.3165V7.0915C1.66602 8.27484 2.19935 8.7415 3.52435 8.7415H6.89102C8.21602 8.74984 8.74935 8.27484 8.74935 7.09984Z"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.74935 16.475V13.1083C8.74935 11.7833 8.21602 11.25 6.89102 11.25H3.52435C2.19935 11.25 1.66602 11.7833 1.66602 13.1083V16.475C1.66602 17.8 2.19935 18.3333 3.52435 18.3333H6.89102C8.21602 18.3333 8.74935 17.8 8.74935 16.475Z"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.5 12.9165H17.5"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M12.5 16.25H17.5"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      )}
    </>
  );
}
